<script lang="ts">
	/**
	 * Signature — sign-off block.
	 *
	 * Söhne kraftig (no script font — brand uses no handwriting type).
	 * Three sizes, all charcoal on bone, all preceded by an em-dash.
	 *
	 * The default text is impersonal ("Ekavi.") and is used on every
	 * surface — the brand never signs off with a person's name.
	 */

	interface Props {
		size?: 'sm' | 'md' | 'lg';
		text?: string;
		withDash?: boolean;
	}

	let { size = 'md', text = 'Ekavi.', withDash = true }: Props = $props();
</script>

<span class="sig sig-{size}">
	{#if withDash}<span class="dash">—&nbsp;</span>{/if}<span class="name">{text}</span>
</span>

<style>
	.sig {
		font-family: var(--ekavi-font-ui);
		font-weight: var(--ekavi-weight-kraftig);
		color: var(--ekavi-ink-1);
		line-height: 1.2;
		display: inline-block;
		letter-spacing: var(--ekavi-track-headers);
	}
	.sig-sm {
		font-size: var(--ekavi-text-16);
	}
	.sig-md {
		font-size: var(--ekavi-text-20);
	}
	.sig-lg {
		font-size: var(--ekavi-text-28);
	}
	.dash {
		color: var(--ekavi-ink-2);
		font-weight: var(--ekavi-weight-buch);
	}
	.name {
		font-style: italic;
	}
</style>
